import classNames from 'classnames';
import PropTypes from 'prop-types';

import { RoundButtonWithIcon } from '@spotahome/ui-library';

import './RoundButtonWithIconWrapper.scss';

const RoundButtonWithIconWrapper = ({ children = null, ...rest }) => (
  <div className={classNames('roundButtonWithIconWrapper')}>
    <RoundButtonWithIcon {...rest}>{children}</RoundButtonWithIcon>
  </div>
);

RoundButtonWithIconWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default RoundButtonWithIconWrapper;
